export default __webpack_public_path__ + "static/media/arrowRight.9e6f2c63.svg";